import React from "react";
import $ from 'jquery';
import Tools from './utils/Tools';
var strings = Tools.getStrings();

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        $('.loadingContainerv2').show();
        
        this.state = {
            googleInited: false,
            addressLat:null,
            addressLng:null,
            promocode:"",
            street:"",
            door:"",
            floor:"",
            postal_code:"",
            city:"",
            obs:"",
            nif:"",
            email:"",
            billing_address:"",
            billing_name:"",
            first_name:"",
            last_name:"",
            password: "",
            confirmpassword: "",
            hasActiveOrder:false,
            myOrderId:0,
            status:0,
            deliveryMethod:"1",
            url:"",
            favorites:[],
            hasFavorites:false,
            currentOpen:"",
            urserInfo:{orders_last:[]},
            payed: 0,
            payment_method: "1",
            step: "validar",
            loading: true,
            locations: {
				casa: {
					label: "casa",
					latitudeDelta: 0.025,
					longitudeDelta: 0.025,
					latitude: 38.7222524,
					longitude: -9.1393366,
					street: "",
					door: "",
					city: "",
					postal_code: "",
                    country: "Portugal",
				},
				trabalho: null,
				outra: null
            },
            addressLabel: "casa",
        };

        this.changeData = this.changeData.bind(this);
        this.stateChange = this.stateChange.bind(this);
    }

    componentDidMount() {
        window.WebApp.getAccount().authCheck((result) => {
            if(!result.expired) {
                this.initLogged();
            } else {
                window.location.href = "/login";
            }
        });

        this.initGoogleAddresss();

        let section = window.location.href.split('#');
        if(section.length > 1) {
            section = section[1];
        }
        switch (section) {
            case 'dados':
                this.toggle('.personal-toggle');
                $('html, body').animate({
                    scrollTop: $('.personal-toggle').offset().top - 180
                }, 500);
                break;
            case 'encomenda':
                this.toggle('.order-toggle');
                $('html, body').animate({
                    scrollTop: $('.order-toggle').offset().top - 180
                }, 500);
                break;
            case 'historico':
                this.toggle('.history-toggle');
                $('html, body').animate({
                    scrollTop: $('.history-toggle').offset().top - 180
                }, 500);
                break;
            default:
                break;
        }
    }

    initGoogleAddresss() {
        var component = this;

        console.log("init google");
        component.state.googleInited = true;
        var input = document.getElementById('google-address');
        var autocomplete = new window.google.maps.places.Autocomplete(input);
        autocomplete.setComponentRestrictions({'country': ['pt']});

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
            for (var i = 0; i < place.address_components.length; i++) {
                if (place.address_components[i].types !== undefined) {
                    if (place.address_components[i].types[0] === "locality") {
                        component.state.city = place.address_components[i].long_name;
                    }
                    if (place.address_components[i].types[0] === "route") {
                        component.state.address = place.address_components[i].long_name;
                    }
                    if (place.address_components[i].types[0] === "street_number") {
                        component.state.door = place.address_components[i].long_name;
                    }
                }
            }
            component.setState({
                addressLat:place.geometry.location.lat(),
                addressLng:place.geometry.location.lng()
            })
        });
    }

    initLogged() {
        window.WebApp.getPubsub().listenOrdersStateChange("a100","https://a100.goapi2.outdarego.eu:9022/sockets",this.stateChange);

        $('document').on('keypress','#google-address', function() {
            console.log("deleted.");
            this.setState({
                addressLat:null,
                addressLng:null,
            });
        }.bind(this));

        window.WebApp.getAccount().getProfile((result) => {
            var user = result.user;
            var street = localStorage.getItem('savedaddress') == null ? "" : localStorage.getItem('savedaddress');
            var door = "";
            var floor = "";
            var billing_address = "";
            var billing_name = "";
            var nif = "";
            var city = "";
            var postal_code = "";
            var first_name = "";
            var last_name = "";
            var lat = null;
            var lng = null;
            var email = "";
            let locations = this.state.locations;
                        
            if(user.billingProfile.nif !== null) {
                nif = user.billingProfile.nif;
                if(user.billingProfile.billing_addresses[0] !== undefined && user.billingProfile.billing_addresses[0].address !== "") {
                    billing_address = user.billingProfile.billing_addresses[0].address.split(" | ")[0];
                    billing_name = user.billingProfile.billing_addresses[0].country;
                }
            }

            if(result.locations !== undefined) {
                locations = result.locations;
                let location = locations["casa"];
                if(location !== null) {
                    street = location.street;
                    floor = location.floor;
                    door = location.door;
                    city = location.city;
                    postal_code = location.postal_code;
                }
            }

            first_name = user.billingProfile.first_name;
            last_name = user.billingProfile.last_name;
            email = user.email;

            localStorage.setItem('clientname', first_name);

            this.setState({
                street:street,
                door:door,
                floor:floor,
                city:city,
                locations,
                billing_address:billing_address,
                billing_name:billing_name,
                nif:nif,
                addressLat:lat,
                addressLng:lng,
                urserInfo:user.billingProfile,
                postal_code:postal_code,
                first_name:first_name,
                last_name:last_name,
                email:email,
                loading: false
            }, () => $('.loadingContainerv2').hide());
        });

        window.WebApp.getAccount().getActiveOrder((result) => {
            if(result.orderId !== undefined) {
                if(result.orderId !== 0){
                    var deliveryMethod = "1";
                    if(result.deliveryMethod !== null) {
                        deliveryMethod = result.deliveryMethod;
                    }
                    if(result.order === undefined) {
                        result.order = {items:[]};
                    }
                    this.setState({
                        myOrderId:result.orderId,
                        status: result.status,
                        deliveryMethod: deliveryMethod,
                        hasActiveOrder:true,
                        payed: result.order.payed,
                        payment_method: result.order.payment_method
                    });
                }else {
                    this.setState({
                        hasActiveOrder:false
                    });
                }
            }
        });
    }

    logout() {
        window.WebApp.getAccount().logout((result) => {
            window.location.href="/areapessoal";
        });
    }

    stateChange(orderInfo){
        var info = $.parseJSON(orderInfo);
        var orderStatus = info.status;
        var courier = info.courier;
        if(info.orderId === this.state.myOrderId){
            $('.tracker-step').removeClass('active');
            $('.step-'+orderStatus).addClass('active');
            this.setState({
                status: orderStatus,
                courier: courier,
                payed: info.payed === undefined ? 0 : info.payed
            });
        }
    }

    changeData(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    updateProfile() {
        $('.loadingContainerv2').show();
        var validated = true;
        if(this.state.first_name === "") {
            $('input[name="first_name"]').addClass('error');
            validated = false;
        }else {
            $('input[name="first_name"]').removeClass('error');
        }
        if(this.state.last_name === "") {
            $('input[name="last_name"]').addClass('error');
            validated = false;
        }else {
            $('input[name="last_name"]').removeClass('error');
        }

        if(validated) {
            var data = {billingAddress:this.state.billing_address,
            billingDoor:"", billingName:this.state.billing_name, billingNif:this.state.nif, name:this.state.first_name,
            last_name:this.state.last_name, address_lat:this.state.addressLat, address_lng:this.state.addressLng,
            email:this.state.email};

            window.WebApp.getAccount().updateProfile(data, (result) => {
                this.toggle(this.state.currentOpen);
                $('.loadingContainerv2').hide();
            });
        }
    }

    updateAddresses() {
        $('.loadingContainerv2').show();
        let locations = this.state.locations;
        if(locations[this.state.addressLabel] === null) {
            locations[this.state.addressLabel] = {};
        }
        locations[this.state.addressLabel].street = this.state.street;
        locations[this.state.addressLabel].city = this.state.city;
        locations[this.state.addressLabel].door = this.state.door;
        locations[this.state.addressLabel].postal_code = this.state.postal_code;
        locations[this.state.addressLabel].floor = this.state.floor;
        let data = {addresses: locations};
        window.WebApp.getAccount().updateAddresses(data, (result) => {
            this.toggle(this.state.currentOpen);
            $('.loadingContainerv2').hide();
        });
    }

    toggle(div) {
        $(div).slideToggle('fast');
        if($(div).parent().find('.arrow').hasClass('active')) {
            $(div).parent().find('.arrow').removeClass('active');
        }else {
            $(div).parent().find('.arrow').addClass('active');
        }

        this.setState({
            currentOpen:div
        });
    }

    getProduct(order, itemId) {
        return order.products.filter(function(elem, index) {
            return elem.id === itemId;
        })[0];
    }

    repeatOrder(order) {
        let description = JSON.parse(order.description);
        let menus = description.menus;
        for(var i = 0; i < menus.length; i++) {
            window.WebApp.getCart().addMenu(menus[i],function() {});
        }

        for(i = 0; i < order.items.length; i++) {
            var product = this.getProduct(order, order.items[i].product_id);
            product.quantity = order.items[i].quantity;
            window.WebApp.getCart().addExtra(product,function() {});
        }

        $('.order-'+order.id).text("ADICIONADO!");
        setTimeout(function(){
            $('.order-'+order.id).text("REPETIR ENCOMENDA");
        },4000);
    }

    splitAtFirstSpace(str) {
        if (!str) return [];
        var i = str.indexOf(' ');
        if (i > 0) {
            return [str.substring(0, i), str.substring(i + 1)];
        }
        else return [str];
    }

    changeLabel(label) {
		if(label !== this.state.addressLabel) {
            let locations = this.state.locations;
            if(locations[this.state.addressLabel] === null) {
                locations[this.state.addressLabel] = {};
            }
            locations[this.state.addressLabel].street = this.state.street;
            locations[this.state.addressLabel].city = this.state.city;
            locations[this.state.addressLabel].door = this.state.door;
            locations[this.state.addressLabel].postal_code = this.state.postal_code;
            locations[this.state.addressLabel].floor = this.state.floor;
            if(this.state.locations[label] !== null) {
				let street = this.state.locations[label].street;
				let city = this.state.locations[label].city;
				let door = this.state.locations[label].door;
				let postal_code = this.state.locations[label].postal_code;
				let floor = "";
				if(this.state.locations[label].floor !== undefined && this.state.locations[label].floor !== null) {
					floor = this.state.locations[label].floor;
				}
				this.setState({
					street,
					city,
					door,
					postal_code,
                    floor,
                    locations
				});
			} else {
                this.setState({
					street: "",
					city: "",
					door: "",
					postal_code: "",
                    floor: "",
                    locations,
				});
            }
			this.setState({addressLabel:label});
		}
    }

    render() {
        return (
            <div className="profile-page header-padding">
                <div className="banner" style={{backgroundImage:'url('+window.banner+')'}}>
                    <div className="trailer-wrapper">
                        <div className="trailer">
                            <h2 className="title white">
                                {strings.hi} {this.state.first_name}
                            </h2>
                            <p className="white">{strings.hiText}</p>
                            <a href="/loja">
                                <button className="white-border" style={{width:"180px", margin:"50px auto 0px auto", textTransform:"uppercase"}}
                                    onClick={() => this.order()}>
                                    {strings.order}
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="profile-section">
                    <div className="profile-wrapper">
                        <div className="flex between">
                            <h3 className="title" onClick={() => this.toggle('.order-toggle')}>
                                {strings.status}
                            </h3>
                            <img className="arrow" alt="toggle" src={window.arrow} onClick={() => this.toggle('.order-toggle')}/>
                        </div>
                        <div className="to-toggle order-toggle">
                            {this.state.hasActiveOrder &&
                                <div className="tracker flex around">
                                    <div className={"tracker-step" + (this.state.status >= 0 ? " active" : "")}>
                                        <img alt="estado" src={window.estado0}/>
                                        {this.state.payment_method === "5" && this.state.payed === 1 &&
                                            <p className="status-text">{strings.tracker0}</p>
                                        }
                                        {(this.state.payment_method !== "5" || this.state.payed === 0) &&
                                            <p className="status-text">{strings.tracker1}</p>
                                        }
                                    </div>
                                    <div className="separator">
                                        <p className="green" style={this.state.status >= 1 ? {opacity:1} : {opacity:0.4}}>------</p>
                                    </div>
                                    <div className={"tracker-step" + (this.state.status >= 1 ? " active" : "")}>
                                        <img alt="estado" src={window.estado1}/>
                                        <p className="status-text">{strings.tracker2}</p>
                                    </div>
                                    <div className="separator">
                                    <p className="green" style={this.state.status >= 2 ? {opacity:1} : {opacity:0.4}}>------</p>
                                    </div>
                                    <div className={"tracker-step" + (this.state.status >= 2 ? " active" : "")}>
                                        <img alt="estado" src={window.estado2}/>
                                        <p className="status-text">{this.state.deliveryMethod === "1" ? strings.tracker3 : strings.tracker31}</p>
                                    </div>
                                    {this.state.deliveryMethod === "1" &&
                                        <div className="separator">
                                        <p className="green" style={this.state.status >= 3 ? {opacity:1} : {opacity:0.4}}>------</p>
                                        </div>
                                    }
                                    {this.state.deliveryMethod === "1" &&
                                        <div className={"tracker-step" + (this.state.status >= 3 ? " active" : "")}>
                                            <img alt="estado" src={window.estado3}/>
                                            <p className="status-text">{strings.tracker4}</p>
                                        </div>
                                    }
                                    <div className="separator">
                                    <p className="green" style={this.state.status >= 4 ? {opacity:1} : {opacity:0.4}}>------</p>
                                    </div>
                                    <div className={"tracker-step" + (this.state.status >= 4 ? " active" : "")}>
                                        <img alt="estado" src={window.estado4}/>
                                        <p className="status-text">{strings.tracker5}</p>
                                    </div>
                                </div>
                            }
                            {!this.state.hasActiveOrder &&
                                <div style={{textAlign:"left"}}>
                                    <p>{strings.noorders}</p>
                                    <a href="/loja"><button style={{marginTop:"30px", textTransform:"uppercase", width: "250px"}}>{strings.order}</button></a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="profile-section">
                    <div className="profile-wrapper">
                        <div className="flex between">
                            <h3 className="title" onClick={() => this.toggle('.personal-toggle')}>
                                {strings.personalData}
                            </h3>
                            <img className="arrow" alt="toggle" src={window.arrow} onClick={() => this.toggle('.personal-toggle')}/>
                        </div>
                        <div className="to-toggle personal-toggle">
                            <div className="flex between" style={{alignItems:"flex-start"}}>
                                <div style={{flex: 1}}>
                                    <h4>{strings.account}</h4>
                                    <input name="first_name" value={this.state.first_name}
                                        type="text" placeholder="Nome" style={{flex:1}} onChange={this.changeData}/><br/>
                                    <input name="last_name" value={this.state.last_name}
                                        type="text" placeholder="Apelido" style={{flex:1}} onChange={this.changeData}/><br/>
                                    <input name="email" value={this.state.email} disabled={window.tipo === "btb" ? true : false}
                                        type="email" placeholder="Email" style={{flex:1}} onChange={this.changeData}/>
                                    <input name="password" value={this.state.password}
                                        type="password" placeholder="Password" style={{flex:1}} onChange={this.changeData}/>
                                    <input name="confirmpassword" value={this.state.confirmpassword}
                                        type="password" placeholder="Confirmar password" style={{flex:1}} onChange={this.changeData}/>
                                </div>
                                <div style={{flex: 1}}>
                                    <h4>{strings.billingData}</h4>
                                    <input name="billing_name" value={this.state.billing_name} disabled={window.tipo === "btb" ? true : false}
                                        type="text" placeholder="Nome" style={{flex:1}} onChange={this.changeData}/><br/>
                                    <input name="nif" value={this.state.nif} disabled={window.tipo === "btb" ? true : false}
                                        type="tel" placeholder="NIF" style={{flex:1}} onChange={this.changeData}/><br/>
                                    <input name="billing_address" value={this.state.billing_address} disabled={window.tipo === "btb" ? true : false}
                                        type="text" placeholder="Morada" style={{flex:1}} onChange={this.changeData}/>
                                </div>
                            </div>
                            <button onClick={() => this.updateProfile()} style={{width:"250px", margin: "30px 5px"}}>{strings.save}</button>
                        </div>
                    </div>
                </div>
                <div className="profile-section">
                    <div className="profile-wrapper">
                        <div className="flex between">
                            <h3 className="title" onClick={() => this.toggle('.billing-toggle')}>
                                {strings.deliveryaddr}
                            </h3>
                            <img className="arrow" alt="toggle" src={window.arrow} onClick={() => this.toggle('.billing-toggle')}/>
                        </div>
                        <div className="to-toggle billing-toggle">
                            <div className="flex start">
                                <button className={"address-label" + (this.state.addressLabel !== "casa" ? " white-btn" : "")}
                                onClick={() => this.changeLabel("casa")} style={{width:"auto", margin:"0px 10px 10px 5px", textTransform:"capitalize"}}>
                                    {window.tipo === "btb" ? strings.home1 : strings.home}
                                </button>
                                <button className={"address-label" + (this.state.addressLabel !== "trabalho" ? " white-btn" : "")}
                                onClick={() => this.changeLabel("trabalho")} style={{width:"auto", margin:"0px 10px 10px 0px", textTransform:"capitalize"}}>
                                    {window.tipo === "btb" ? strings.work1 : strings.work}
                                </button>
                                <button className={"address-label" + (this.state.addressLabel !== "outra" ? " white-btn" : "")}
                                onClick={() => this.changeLabel("outra")} style={{width:"auto", margin:"0px 10px 10px 0px", textTransform:"capitalize"}}>
                                    {window.tipo === "btb" ? strings.other1 : strings.other}
                                </button>
                            </div>
                            <div className="flex between">
                                <input id="google-address" key={3} type="text" disabled={window.tipo === "btb" ? true : false}
                                placeholder={strings.address} name="street" value={this.state.street} onChange={this.changeData}/>
                                <input name="city" value={this.state.city} disabled={window.tipo === "btb" ? true : false}
                                    type="text" placeholder="Zona" style={{flex:1}} onChange={this.changeData}/>
                            </div>
                            <div className="flex between">
                                <input name="postal_code" value={this.state.postal_code} disabled={window.tipo === "btb" ? true : false}
                                    type="text" placeholder="Código postal" style={{flex:1}} onChange={this.changeData}/>
                                <input name="door" value={this.state.door} disabled={window.tipo === "btb" ? true : false}
                                    type="text" placeholder="Porta" style={{flex:1}} onChange={this.changeData}/>
                                <input name="floor" value={this.state.floor} disabled={window.tipo === "btb" ? true : false}
                                    type="text" placeholder="Andar" style={{flex:1}} onChange={this.changeData}/>
                            </div>
                            <button style={{width:"250px", margin:"30px 5px"}} onClick={() => this.updateAddresses()}>{strings.save}</button>
                        </div>
                    </div>
                </div>
                <div className="profile-section">
                    <div className="profile-wrapper">
                        <div className="flex between">
                            <h3 className="title" onClick={() => this.toggle('.history-toggle')}>
                                {strings.history}
                            </h3>
                            <img className="arrow" alt="toggle" src={window.arrow} onClick={() => this.toggle('.history-toggle')}/>
                        </div>
                        <div className="to-toggle history-toggle">
                            {this.state.urserInfo.orders_last.map((order, index) => {
                                let description = JSON.parse(order.description);
                                if(description.menus.length > 0 || order.items.length > 0) {
                                    return (
                                        <div className="history-order" key={index}>
                                            <p className="history-header">
                                                <span className="green">{strings.singOrder}: </span>
                                                <span className="green">{order.created_at.split(' ')[0]} |</span>
                                                <span className="green"> {description.hours} | </span>
                                                <span className="green"> {description.delivery_method === "1" ? "Home delivery" : "Take-away"}</span>
                                            </p>
                                            <div className="history-table">
                                                <div className="flex between">
                                                    <p style={{flex:1}}>Item</p>
                                                    <p style={{textAlign:"center",flex:0.5}}>Qnt</p>
                                                    <p style={{textAlign:"right",flex:0.5}}>{strings.price}</p>
                                                </div>
                                                <hr style={{borderTop:"1 px solid #aba09a",margin:"7px 0px"}}/>
                                                {description.menus.map((product, index2) => {
                                                    return (
                                                        <div key={index2} className="flex between">
                                                            <p style={{flex:1}}>{product.name}</p>
                                                            <p style={{textAlign:"center",flex:0.5}}>{product.quantity}</p>
                                                            <p style={{textAlign:"right",flex:0.5}}>{product.price.toFixed(2)}€</p>
                                                        </div>
                                                    )
                                                })}
                                                {order.items.map((product, index2) => {
                                                    let qnt = product.quantity;
                                                    product = this.getProduct(order, product.product_id);
                                                    return (
                                                        <div key={index2} className="flex between">
                                                            <p style={{flex:1}}>{product.name}</p>
                                                            <p style={{textAlign:"center",flex:0.5}}>{qnt}</p>
                                                            <p style={{textAlign:"right",flex:0.5}}>{product.price.toFixed(2)}€</p>
                                                        </div>
                                                    )
                                                })}
                                                <hr style={{borderTop:"1 px solid #aba09a",margin:"7px 0px"}}/>
                                                <div className="flex between">
                                                    <p className="bold" style={{flex:1}}>Total</p>
                                                    <p className="bold" style={{textAlign:"center",flex:0.5}}></p>
                                                    <p className="bold" style={{textAlign:"right",flex:0.5}}>{order.total}€</p>
                                                </div>
                                            </div>
                                            <button className={"order-" + order.id}
                                            style={{margin:"0px auto 10px auto",width:"220px", textTransform: "uppercase"}}
                                            onClick={() => this.repeatOrder(order)}>
                                                {strings.repeat}
                                            </button>
                                            {true === false &&
                                                <a href={"/info/feedback?order="+order.id}>
                                                    <p className="btn red smooth" style={{width:"180px",marginBottom:"20px"}}>
                                                        Feedback
                                                    </p>
                                                </a>
                                            }
                                        </div>
                                    )
                                }
                                return null;
                            })}
                            {this.state.urserInfo.orders_last.length === 0 &&
                                <p>
                                    {strings.nohistory}
                                </p>
                            }
                        </div>
                    </div>
                </div>
                <p style={{textAlign:"center", marginTop:"20px", paddingBottom:"40px", cursor: "pointer"}} onClick={() => this.logout()}><u>logout</u></p>
            </div>
        );
    }
}
